<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <h1 class="modal__title">{{ 'pages.tables.modal.title' | translate }}</h1>
  <form class="modal__form" novalidated [formGroup]="addTable" (submit)="addNewTable(addTable)">
    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.name' | translate }}</mat-label>
      <input matInput appFormInputTrim formControlName="name">
      <mat-error *ngIf="addTable.controls.name.touched">
        <span *ngIf="addTable.controls.name.errors?.required">
          {{ 'pages.tables.modal.mandatoryField' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.number' | translate }}</mat-label>
      <input matInput type="text" inputmode="numeric" appFormInputTrim formControlName="number">
      <mat-error *ngIf="addTable.controls.number.touched && addTable.controls.number.invalid">
        <span *ngIf="addTable.controls.number.errors?.pattern || addTable.controls.number.errors?.min">
          {{ 'pages.tables.modal.positiveNumber' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-tab-group class="table-connection-tabs" (selectedIndexChange)="onConnectionTypeChange($event)">
      <mat-tab label="{{ 'pages.tables.modal.widgetCodeTab' | translate }}">
        <mat-form-field class="login-wrap__text">
          <input type="text" matInput appFormInputTrim formControlName="widgetCode">
          <mat-error *ngIf="addTable.controls.widgetCode.touched">
            <span *ngIf="addTable.controls.widgetCode.errors?.required">
              {{ 'pages.tables.modal.mandatoryField' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-tab>

      <mat-tab label="{{ 'pages.tables.modal.dwallDeviceIdTab' | translate }}">
        <mat-form-field class="login-wrap__text">
          <input matInput appFormInputTrim inputmode="numeric" maxlength="12" formControlName="dwallDeviceId">
          <mat-error *ngIf="addTable.controls.dwallDeviceId.touched && addTable.controls.dwallDeviceId.invalid">
            <span *ngIf="addTable.controls.dwallDeviceId.errors?.required">
              {{ 'pages.tables.modal.mandatoryField' | translate }}
            </span>
            <span *ngIf="addTable.controls.dwallDeviceId.errors?.pattern">
              {{ 'pages.tables.modal.dwallDeviceIdPattern' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>

    <mat-form-field class="login-wrap__text">
      <mat-label>{{ 'pages.tables.modal.notes' | translate }}</mat-label>
      <input matInput appFormInputTrim formControlName="description">
    </mat-form-field>

    <div class="login-wrap__text">
      <mat-label >{{ 'pages.tables.content.qr' | translate }}</mat-label>
      <app-form-file-upload
        appDragAndDropFiles
        formControlName="QRCodeFile"
        accept="image/jpg, image/png"
        (change)="onQrFileChange($event)"
      >
        {{ 'formFilUpload.dragAndDrop' | translate }}
      </app-form-file-upload>
    </div>
    <div class="modal__submit-btn">
      <button class="btn btn__primary" type="submit" [disabled]="addTable.invalid || isUploading">
        {{ 'pages.tables.modal.create' | translate }}
      </button>
    </div>
  </form>
</div>
